import React from "react";

const mapEmbeded = `<div style="width: 100%"><iframe width="100%" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=320&amp;hl=en&amp;q=%D0%A1%D1%82%D0%B0%D1%80%D0%B8%D1%8F%20%D0%A7%D0%B8%D0%BD%D0%B0%D1%80%20-%20%D0%9F%D0%BE%D1%80%D1%82%20%D0%92%D0%B0%D1%80%D0%BD%D0%B0+(%D0%A1%D1%82%D0%B0%D1%80%D0%B8%D1%8F%20%D0%A7%D0%B8%D0%BD%D0%B0%D1%80%20-%20%D0%9F%D0%BE%D1%80%D1%82%20%D0%92%D0%B0%D1%80%D0%BD%D0%B0)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/collections/drones/">best drones</a></iframe></div>`;

export default function Transport() {
  return (
    <div className="p-top-8 p-bottom-8 transport transport--bg" id="transport">
      <div className="container p-top-4">
        <h1 className="text-center m-bottom-4">Как да стигна?</h1>
        <div className="flex flex-justify-center text-center">
          <div className="col-12 col-8-xl">
            <p className="text-md m-bottom-2">
              Тук може да намерите GPS координати на ресторанта, намиращ се на Порт Варна. Съветваме ви да дойдете без кола, за да може да се насладите, но ако имате нужда от паркинг, може да използвате платения паркинг в близост до ресторанта. 
            </p>
          </div>
        </div>
        <div className="flex flex-justify-center">
          <div className="col-12 col-6-xl">
            <h2 className="text-center">Стария Чинар - Порт Варна</h2>
            <p className="text-xs text-center">(Цъкни върху "Directions")</p>
            <div className="display-block m-auto p-top-3 p-bottom-5">
              <div
                className="map-location"
                dangerouslySetInnerHTML={{ __html: mapEmbeded }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
